import { render, staticRenderFns } from "./OddBoostBadge.vue?vue&type=template&id=36707241&scoped=true"
import script from "./OddBoostBadge.vue?vue&type=script&lang=js"
export * from "./OddBoostBadge.vue?vue&type=script&lang=js"
import style0 from "./OddBoostBadge.vue?vue&type=style&index=0&id=36707241&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36707241",
  null
  
)

export default component.exports